export default __webpack_public_path__ + "locales/ko-KR/ChangePortalOwner.json?hash=0c89b4e536c915c86d14d97ff2682486";